import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    color: "primary",
    label: "Activo / Inactivo"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_q_item, { tag: "label" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, {
                side: "",
                top: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_checkbox, {
                    modelValue: _ctx.activeComputed,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeComputed) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Activos")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })), [
            [_directive_ripple]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_q_item, { tag: "label" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, {
                side: "",
                top: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_checkbox, {
                    modelValue: _ctx.inactiveComputed,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inactiveComputed) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Inactivos")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })), [
            [_directive_ripple]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}